import { SessionExpiredDialog } from '@rio-cloud/rio-session-expired-info';

import { DEFAULT_LOCALE } from '#configuration/lang/lang.ts';
import { useLocale } from '#configuration/lang/langSlice.ts';
import { useIsUserSessionExpired } from '#configuration/login/loginSlice.ts';
import { useAppDispatch } from '#configuration/setup/hooks.ts';

import { hideSessionExpiredDialog, useSessionExpiredAcknowledged } from '../../data/appSlice.ts';

const SessionExpiredInfo = () => {
    const dispatch = useAppDispatch();

    const userLocale = useLocale();
    const isSessionExpired = useIsUserSessionExpired();
    const sessionExpiredAcknowledged = useSessionExpiredAcknowledged();

    const handleSessionExpiredDialogClose = () => dispatch(hideSessionExpiredDialog());
    const showSessionExpired = isSessionExpired && !sessionExpiredAcknowledged;

    return (
        <SessionExpiredDialog
            locale={userLocale || DEFAULT_LOCALE}
            onClose={handleSessionExpiredDialogClose}
            show={showSessionExpired}
        />
    );
};

export default SessionExpiredInfo;
